"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const bookmarkbrand02 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 55 68",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-bookmarkbrand02` : '') + (description ? ` desc-bookmarkbrand02` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-bookmarkbrand02"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-bookmarkbrand02"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.087 5h-48a2 2 0 0 0-2 2v58.667l.018.274c.198 1.513 2.022 2.284 3.253 1.269l22.729-18.724L50.816 67.21c1.304 1.076 3.27.147 3.27-1.543V7a2 2 0 0 0-2-2Z",
    fill: "#FFCCD8",
    fillOpacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("mask", {
    id: "a",
    style: {
      "maskType": "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: "2",
    y: "5",
    width: "53",
    height: "63"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.087 5h52v62.67h-52V5Z",
    fill: "#FFC599",
    fillOpacity: ".5"
  })), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1a1 1 0 0 1 1-1h50.087a1 1 0 0 1 1 1v64a1 1 0 0 1-1.653.758l-24.39-21.004L1.653 65.758A1 1 0 0 1 0 65V1Zm2 1v60.82l23.391-20.143a1 1 0 0 1 1.305 0l23.391 20.142V2H2Z",
    fill: "#E90B5A"
  }));
};
var _default = exports.default = bookmarkbrand02;